<template>
  <div>
    <nav
      id="main-header"
      class="
        navbar
        navbar-expand-md
        fixed-top
        navbar-dark
        justify-content-between
        flex-nowrap
      "
      :class=" {
        'main-header-fixed': headerBackground || !showBanner,
        'shadow-half': headerBackground || !showBanner, mobileActive: navbarMobileVisible,
        headerBackground: headerBackground || !showBanner,
      }"
      :style="[$route.name != 'jobs' ? {} : {}]"
    >
      <div class="container">
        <button
          class="
            hamburger hamburger--slider
            navbar-toggle
            mr-3
            d-lg-none d-xm-block
          "
          :class="{ 'is-active': navbarMobileVisible }"
          type="button"
          @click="toggleMenu"
        >
          <span class="hamburger-box">
            <span class="hamburger-inner"></span>
          </span>
        </button>

        <router-link to="/" class="navbar-brand m-0 mr-auto">
          <img
            src="@/assets/images/logo-inbrands/inbrands.svg"
            alt="Inbrands Logotipo"
          />
        </router-link>

        <div class="d-flex">
          <ul class="navbar-nav navbar-mobile">
            <span class="navbar-mobile-bg" @click="toggleMenu"></span>

            <div class="d-flex flex-column d-lg-none border-bottom" v-if="this.$store.state.user.profile">
              <li class="nav-item">
                <div class="nav-link">
                  <h5 class="m-0">
                    Olá{{ firstName && ", " + firstName }}!
                  </h5>
                </div>
              </li>

              <li class="nav-item" @click="toggleMenu">
                <router-link to="/meu-perfil" class="nav-link">
                  Meu Perfil
                </router-link>
              </li>

              <li class="nav-item">
                <a href="#" class="nav-link" @click="changeModal('change-password')">
                  Alterar Senha
                </a>
              </li>

              <li class="nav-item">
                <a href="#" class="nav-link" @click="signOut">Sair</a>
              </li>
            </div>

            <li class="nav-item" @click="toggleMenu">
              <router-link to="/#mission-values" class="nav-link">
                Nossa missão e valores
              </router-link>
            </li>

            <li class="nav-item" @click="toggleMenu">
              <router-link to="/#marcas-parceiras" class="nav-link">
                Marcas parceiras
              </router-link>
            </li>

            <!-- <li class="nav-item" @click="toggleMenu">
              <router-link to="/#faq" class="nav-link uppercase">
                Faq
              </router-link>
            </li> -->

            <li class="nav-item" @click="toggleMenu">
              <router-link to="/vagas" class="nav-link">
                Vagas Abertas
              </router-link>
            </li>

            <li class="nav-item" @click="toggleMenu" v-if="!$store.state.user.isAuth || !$store.state.user.follower">
              <router-link to="/deixe-seu-perfil" class="nav-link">
                <span class="btn btn-blue-ml">
                  Cadastre seu currículo
                </span>
              </router-link>
            </li>

            <li class="nav-item dropdown-profile" @click="toggleMenu" v-if="this.$store.state.user.isAuth">
              <b-dropdown
                size="xl"
                text="Acesse seu perfil"
                class="nav-link"
                no-caret
              >
                <template slot="button-content">
                  <div class="label-dropdown">
                    <div class="label-dropdown-avatar">
                      <account-circle-icon />
                    </div>
                    <p>
                      Olá{{ firstName && `, ${firstName}` }}!
                    </p>
                    <chevron-down-icon class="arrow-down" />
                  </div>
                </template>

                <b-dropdown-item to="/meu-perfil">Meu Perfil</b-dropdown-item>
                <b-dropdown-item @click="changeModal('change-password')">
                  Alterar Senha
                </b-dropdown-item>
                <b-dropdown-item @click="signOut">Sair</b-dropdown-item>
              </b-dropdown>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
  import MagnifyIcon from "vue-material-design-icons/Magnify.vue";
  import AccountCircleIcon from "vue-material-design-icons/AccountCircle.vue"
  import ChevronDownIcon from "vue-material-design-icons/ChevronDown.vue";

  export default {
    name: "MainHeader",
    data() {
      return {
        headerBackground: false,
        navbarMobileVisible: false,
        heroSection: null,
      };
    },
    computed: {
      firstName() {
        if(this.$store.state.user){
          const profile = this.$store.state.user.profile;
          const socialName = profile.socialName;
          const name = profile.name.split(' ')[0];
          if(socialName){
            return socialName;
          } else if(window.signUp){
            return null
          } else if(name){
            return name;
          }
        }

        return null;
      },
      
      showBanner() {
        if (
          this.$route.name == "ficha" ||
          this.$route.name == "testes" ||
          this.$route.name == "capa-teste" ||
          this.$route.name == "pending-tests" ||
          this.$route.name == "teste"
        ) {
          return false;
        } else {
          return true;
        }
      },
    },
    components: {
      MagnifyIcon,
      AccountCircleIcon,
      ChevronDownIcon
    },
    methods: {
      handleScroll(event) {
        let scrolledAfter = this.heroSection
          ? this.heroSection.offsetHeight - 80
          : -1;
        let scrollY = window.scrollY || window.pageYOffset;

        if (scrollY > 100) {
          this.headerBackground = true;
        } else {
          this.headerBackground = false;
        }
      },
      toggleMenu() {
        this.navbarMobileVisible = !this.navbarMobileVisible;
        const intercomBtn = document.querySelector(".intercom-launcher-frame");
        if (intercomBtn) {
          if (this.navbarMobileVisible) {
            intercomBtn.classList.add("show");
          } else {
            intercomBtn.classList.remove("show");
          }
        }
      },
      signOut() {
        this.$store.dispatch("user/signOut");
        if (this.$route.meta.requiresAuth) this.$router.push("/");
      },
      changeModal(target) {
        this.$store.commit("DEVISE_FORM", target);
      },
    },
    mounted() {
      this.heroSection = document.querySelector(".hero");
      this.handleScroll();
      window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    watch: {
      $route(to, from) {
        this.heroSection = document.querySelector(".hero");
        this.handleScroll();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .navbar {
    background-color: #fff;
    .full-color {
      position: absolute;
      top: -4px;
      left: 0;
    }
    @include media-breakpoint-down(sm) {
      padding: 0px 1rem;
      height: 80px;
    }
    &.headerBackground {
      padding: 0.5rem 0px;
      .navbar-brand {
        img.logo-white {
          display: block;
        }
        &::before {
          display: none;
        }
      }
      @include media-breakpoint-down(sm) {
        padding: 0px 1rem;
        height: 50px;
      }
    }
    .hamburger {
      .hamburger-inner {
        background-color: #000;
        &::before, &::after {
          background-color: #000;
        }
      }
    }
    .navbar-brand {
      position: relative;
      width: 190px;
      @include media-breakpoint-down(sm) {
        width: 130px;
        margin: 0 !important;
      }
      img {
        display: block;
        &.logo-white {
          display: none;
        }
      }
    }
    .nav-item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .nav-link {
        width: 100%;
        font-size: 16px;
        font-weight: 400;
        line-height: 19px;
        color: #000;
        @include media-breakpoint-up(lg) {
          text-align: center;
        }
        &.uppercase {
          text-transform: uppercase;
        }
        &:hover, &:active, &:focus {
          color: theme-color(primary);
        }
      }
      &:last-of-type {
        .nav-link {
          padding-right: 0;
        }
      }
      &.dropdown-profile {
        margin-right: 0;
        @include media-breakpoint-down(md) {
          display: none;
        }

        /deep/ .btn{
          background: none;
          border: none;
        }

        .label-dropdown {
          display: flex;
          align-items: center;
          color: #000;
          &-avatar {
            margin-right: 8px;
            /deep/ svg{
              width: 30px;
              height: 30px;
            }
          }
          p {
            font-size: 16px;
            font-weight: 400;
            line-height: 36px;
            color: #000;
            margin: 0;
          }
          /deep/ .arrow-down {
            margin-left: 4px;
            svg{
              width: 20px;
            }
          }
        }
      }
    }
    &.mobileActive {
      .navbar-mobile {
        transform: translateX(0vw);
        .navbar-mobile-bg {
          opacity: 1;
          visibility: visible;
        }
      }
    }
    .navbar-mobile {
      .navbar-mobile-bg {
        display: none;
      }
      @include media-breakpoint-down(md) {
        width: 290px;
        position: fixed;
        left: 0;
        top: 0;
        height: 100%;
        background: #fff;
        z-index: 10;
        transform: translateX(-100vw);
        transition: transform 0.3s ease-in-out;
        flex-direction: column !important;
        .nav-item {
          width: 100%;
          &.active {
            .nav-link {
              background-color: theme-color("light-dark") !important;
              border-bottom: none !important;
            }
          }
          .nav-link {
            color: $body-color !important;
            padding: 1rem !important;
            font-weight: 400 !important;
            text-transform: uppercase !important;
            &:hover {
              background-color: theme-color("light-dark") !important;
            }
          }
        }
        .navbar-mobile-bg {
          display: block;
          width: 200vw;
          height: 100%;
          position: fixed;
          left: 290px;
          right: 0;
          background: rgba(0, 0, 0, 0.7);
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.2s ease-in-out 0.1s, visibility 0.01s linear;
        }
      }
    }
  }
</style>
